/** @format */

import { Component, OnInit } from '@angular/core';

import { HttpService } from '@shared/data-access/services';
import { Title } from '@angular/platform-browser';
import { chain } from '@core/chain';
import { DynamicProductTemplateModules } from '@pdp/data-access/enums';

@Component({
	selector: 'pdp-templates-not-found',
	templateUrl: './not-found.component.html',
	styleUrl: './not-found.component.scss',
	standalone: false
})
export class NotFoundComponent implements OnInit {
	constructor(
		private title: Title,
		private httpService: HttpService
	) {}

	readonly templateName = DynamicProductTemplateModules.NOT_FOUND_DEFAULT as const;

	ngOnInit() {
		// Set the HTTP Status Code to 404
		this.httpService.setStatusCode(404);
		// Set page title
		this.title.setTitle(`Page Not Found | ${chain.chainName}`);
	}
}
